exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*:host {\r\n  background-color: #106cc8;\r\n  color: rgba(255, 255, 255, 0.87);\r\n  display: block;\r\n  height: 48px;\r\n  padding: 0 16px;\r\n}\r\n\r\nh1 {\r\n  display: inline;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n  letter-spacing: 0.1px;\r\n  line-height: 48px;\r\n}\r\n\r\n.more {\r\n  background: url(\"./assets/svg/more.svg\");\r\n  float: right;\r\n  height: 24px;\r\n  margin-top: 12px;\r\n  width: 24px;\r\n}*/\n:host {\n  z-index: 9999; }\n.fixed.menu {\n  height: 50px;\n  background-color: #fff;\n  border-bottom: 1px solid #c2cfd6; }\n.user-menu {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/toolbar/toolbar.component.scss
// module id = ../../../../../src/app/shared/toolbar/toolbar.component.scss
// module chunks = main